import React from 'react';

const formatScore = (evaluation) => {
  if (evaluation.decisive) return evaluation.label;
  if (evaluation.pawns === 0) return '0.0';
  return `${evaluation.pawns > 0 ? '+' : ''}${evaluation.pawns.toFixed(1)}`;
};

const EvaluationBar = ({ evaluation }) => {
  const score = formatScore(evaluation);
  const boundary = Math.min(94, Math.max(6, 100 - evaluation.whitePercent));

  return (
    <aside className="evaluation-bar" aria-label="Position evaluation">
      <span className="evaluation-bar__side evaluation-bar__side--black" aria-hidden="true">B</span>
      <div
        className="evaluation-bar__track"
        role="meter"
        aria-label="Position evaluation meter"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={Math.round(evaluation.whitePercent)}
        aria-valuetext={`${evaluation.label}. ${score}`}
        title="Quick local estimate based on material, activity, and king safety"
      >
        <span className="evaluation-bar__white" style={{ height: `${evaluation.whitePercent}%` }} />
        <output className="evaluation-bar__score" style={{ top: `${boundary}%` }}>{score}</output>
      </div>
      <span className="evaluation-bar__side evaluation-bar__side--white" aria-hidden="true">W</span>
    </aside>
  );
};

export default EvaluationBar;
